import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { billing as BillingApi } from '@teem/constants/api';

@Injectable({
  providedIn: 'root'
})

export class BillingService {
  constructor(protected httpClient: HttpClient) { }

  public billingSubscriptionTransaction(id:any) {
    return this.httpClient.get(`${BillingApi.billingSubscriptionTransaction+'/'+id}`)
  }

  public billingInvoiceTransactionHistory(id:any) {
    return this.httpClient.get(`${BillingApi.billingInvoiceTransactionHistory+'/'+id}`)
  }

  public subscriptionList() {
    return this.httpClient.get(`${BillingApi.subscriptionHistory}`)
  }

  public invoiceSubscriptionHistory() {
    return this.httpClient.get(`${BillingApi.invoiceSubscriptionHistory}`)
  }

  offAutoRenew(params: any) {
    return this.httpClient.put(`${BillingApi.offAutoRenew}`, params)
  }

  offInvoiceAutoRenew(params: any) {
    return this.httpClient.put(`${BillingApi.offInvoiceAutoRenew}`, params)
  }

  deleteInvoiceCancelRequest(uuid: string) {
    return this.httpClient.delete(`${BillingApi.deleteInvoiceCancelRequest(uuid)}`)
  }

  deleteCancelRequest(uuid: string) {
    return this.httpClient.delete(`${BillingApi.deleteCancelRequest(uuid)}`)
  }

}
